import type { ProductMediasProps } from "~/components/ui/ProductHeader/components/ProductMedias"

export function getDiptycsIdsFromTemplate(template: ProductMediasProps["template"]): number[][] {
  switch (template) {
    case "half_second_row":
      return [[1, 2]]
    default:
      return [[]]
  }
}
